import { useMemo } from 'react';
import { SEAT_CIRCLE_RADIUS } from '../../constants';
import { radiansToDegrees360, round } from '../../utils/utils';
import { createLabelGenerator } from '../../utils/label-generator';
import { getRowDegrees, getSeatDegrees } from '../../shapes/curved-row/utils';
import { getCirclePoint } from '../../utils/geometry';
export const useGenericCurvedRow = ({ definition, reverse = false }) => {
    const { seatAmount } = definition;
    const fromDegrees = radiansToDegrees360(definition.curveAngleFrom);
    const curveAngleDegrees = getRowDegrees(definition);
    const seatDegrees = getSeatDegrees(definition);
    const getCurveSeatPosition = (index) => {
        const curveCircleCenter = { x: definition.midX, y: SEAT_CIRCLE_RADIUS + definition.curveRadius };
        if (seatAmount === 1) {
            const position = getCirclePoint(fromDegrees + round(curveAngleDegrees / 2), curveCircleCenter, definition.curveRadius);
            return {
                x: round(position.x - SEAT_CIRCLE_RADIUS),
                y: round(position.y - SEAT_CIRCLE_RADIUS),
            };
        }
        const rowDegrees = Math.max(0, curveAngleDegrees - seatDegrees);
        const seatCenterSpacing = rowDegrees / (seatAmount - 1);
        const seatCenter = getCirclePoint(index * seatCenterSpacing + fromDegrees + seatDegrees / 2, curveCircleCenter, definition.curveRadius);
        const position = {
            x: round(seatCenter.x - SEAT_CIRCLE_RADIUS),
            y: round(seatCenter.y - SEAT_CIRCLE_RADIUS),
        };
        return position;
    };
    const labelGenerator = createLabelGenerator(definition);
    const labels = useMemo(() => {
        const newLabels = new Array(seatAmount).fill(null).map((_, index) => labelGenerator.getLabelByIndex(index));
        if (reverse) {
            newLabels.reverse();
        }
        return newLabels;
    }, [seatAmount, reverse, labelGenerator]);
    return { labels, getCurveSeatPosition };
};
//# sourceMappingURL=use-generic-curved-row.js.map